import React from 'react';
import Loading from './loading';

export default function Loadable({ children, loading, text = null, noPadding = false }) {
  if (loading) {
    return <Loading text={text} noPadding={noPadding} />;
  }
  return children;
}